import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted, PropType, Ref, ref, WritableComputedRef } from 'vue';
import {
    ConnectFlowModelingActions,
    ConnectFlowModelingGetters,
    ConnectFlowModelingMutations,
    VueFlowNodeModel,
    SelectOptionsServiceGetConnectFlowsResult,
} from '@/types';
import store from '@/store';
import { ExternalLinkIcon } from '@heroicons/vue/outline';

import { useVuelidate, Validation, ValidationArgs } from '@vuelidate/core';
import { required } from '@/utils/validators';
import { useI18n } from 'vue-i18n';
import { SelectOptionsService } from '@/services';

interface GoToFormState {
    connectFlow: number | null;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'GoToConnectFlow',
  props: {
    node: {
        type: Object as PropType<VueFlowNodeModel>,
        required: true,
    },
},
  setup(__props, { expose: __expose }) {
  __expose();

const props = __props;

const showForm = ref(false);

const nodeWritable: WritableComputedRef<VueFlowNodeModel> = computed({
    get: () => store.getters['flow/' + ConnectFlowModelingGetters.ELEMENT_BY_ID](props.node.id),
    set: (value: VueFlowNodeModel) => {
        store.commit('flow/' + ConnectFlowModelingMutations.UPDATE_ELEMENT, {
            idx: null,
            value,
        });
    },
});

const { t } = useI18n();

const formState: Ref<GoToFormState> = ref({
    connectFlow: null,
});
const rules = computed<ValidationArgs<GoToFormState>>(() => {
    const r: ValidationArgs<GoToFormState> = {
        connectFlow: {
            required,
        },
    };
    return r;
});
const v$: Ref<Validation<ValidationArgs<GoToFormState>>> = useVuelidate(rules, formState);

const isFormCorrect = ref(true);

function removeNode() {
    store.dispatch('flow/' + ConnectFlowModelingActions.DELETE_NODE, {
        nodeId: nodeWritable.value.id,
        parentId: nodeWritable.value.parentId,
    });
}

async function onSubmit() {
    isFormCorrect.value = await v$.value.$validate();
    if (isFormCorrect.value) {
        nodeWritable.value.data.goToConnectFlow = formState.value.connectFlow || undefined;
        showForm.value = false;
    }
    nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    v$.value.$reset();
}

const connectFlowOptions: Ref<SelectOptionsServiceGetConnectFlowsResult[]> = ref([]);

const nodeText = computed(() => {
    let text = t('connectFlow.node.goToConnectFlow.description');
    if (nodeWritable.value.data.goToConnectFlow) {
        const connectFlow = connectFlowOptions.value.find(
            (e) => e.id == nodeWritable.value.data.goToConnectFlow,
        );
        text = connectFlow?.name ?? '';
    }
    return text;
});

onMounted(async () => {
    if (nodeWritable.value.data.goToConnectFlow !== undefined) {
        formState.value.connectFlow = nodeWritable.value.data.goToConnectFlow;
    }

    const { data } = await SelectOptionsService.getConnectFlows();
    connectFlowOptions.value = data;

    v$.value.$validate().then((result) => {
        isFormCorrect.value = result;
        nodeWritable.value.data.hasErrors = !isFormCorrect.value;
    });
});

const __returned__ = { props, showForm, nodeWritable, t, formState, rules, v$, isFormCorrect, removeNode, onSubmit, connectFlowOptions, nodeText, get ExternalLinkIcon() { return ExternalLinkIcon } }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})